<template>
  <m-single-contents-wrapper :content-link="contentLink">
    <b-container class="py-4" fluid slot-scope="{content}">
      <img class="w-100 p-0 m-0 single-page-1-main-image" :src="content.thumbnail" :alt="content.title">
      <b-container>
        <b-col lg="12" class="m-n5 mx-auto ">
          <div class="shadow bg-white single-page-1-body p-5 rounded rounded-4">
            <h1>{{ content.title }}</h1>
            <div class="" v-html="processContent(content.body)"></div>
          </div>
        </b-col>
      </b-container>

    </b-container>

  </m-single-contents-wrapper>

</template>

<script>
import {dateConverter,} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Converter";

export default {
  name: "SinglePost1",
  props: {
    contentLink: {
      default: null
    }
  },
  methods: {
    getPostDate(date) {
      return dateConverter(date, "/", true);
    },
  },
};
</script>

<style>
.single-page-1-body img {
  width: 100%;
}
</style>

<style scoped>

.single-page-1-main-image {
  width: 100%;
  height: 450px;
  object-fit: cover;
}

</style>